<template>
  <div class="page summary-container">
    <LayoutContainer>
      <div class="page-header summary-header">
        <h1 class="title"><i class="fas fa-chart-bar icon"></i> Summary</h1>
        <div class="filter">
          <FilterDate />
        </div>
      </div>
      <div class="page-content">
        <div class="summary-total">
          <SummaryTotal />
        </div>
        <div class="summary-top-video mt-4">
          <SummaryTopVideos />
        </div>
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import generateLink from '@/utils/generateLink';
import SummaryTotal from '@/summary/SummaryTotal.vue';
import SummaryTopVideos from '@/summary/SummaryTopVideos.vue';
import FilterDate from '@/components/FilterDate.vue';
import LayoutContainer from '@/layout/LayoutContainer.vue';

export default {
  mixins: [generateLink],
  components: {
    SummaryTotal,
    SummaryTopVideos,
    FilterDate,
    LayoutContainer,
  },
  computed: {
    ...mapGetters(['currentProject', 'getProjectById']),
    projectId() {
      return this.$route.params.projectId;
    },
  },
  async created() {
    window.scroll(0, 0);
    if (this.currentProject.projectId !== this.projectId) {
      await this.$store.dispatch('setCurrentProject', this.getProjectById(this.projectId));
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
</style>
